module.exports = __webpack_public_path__ + "static/media/test18_4.742c1015.png";